module.exports = __webpack_public_path__ + "img/b2b671a63616320bdd5008d2feb2fb25.png";